import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { Profile } from './Profile.js';

const ProfileContainer = ({ shouldShowOrderDate =true  })=>{
    const { isAABEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement(Profile, {
        isAABEnabled: isAABEnabled,
        shouldShowOrderDate: shouldShowOrderDate
    });
};

export { ProfileContainer as default };
//# sourceMappingURL=ProfileContainer.js.map
